import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/aparat-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/arrow-down.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/basket.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/clip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/close-dark.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/close.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/cloud.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/cookies.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/curved-items-landing-1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/curved-items-landing-2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/curved-items-landing-3.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/curved-items-landing-4.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/dashboard-support.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/data.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/edit.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/enamad.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/instagram-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/like-filled.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/like.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/loginLock.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/my-content.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/op-cp.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/op-design.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/op-dev.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/op-operator.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/orders.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/payment.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/search.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/secure.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/set-blue.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/sharing.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/shield.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/sort.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/support.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/telegram-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/wallet-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/404.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/about-1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/about-2.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/about-3.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/about-4.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/about-5.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/about.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/amoozesh-parvaresh.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/banner.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/brain.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/brainwHead.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/call.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/cat-bg.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/chatinoo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/contact-us.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/contents.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/curved-circle.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/curved-item.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/dart.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/deskwPlayBtn.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/drag&drop.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/elementarySchool.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/emptyBasket.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/emptyContent.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/emptyFavorit.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/emptyFilter.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/emptySupport.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/empyOrders.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/faq.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/filePicking.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/khaje-nasir.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/konkoor.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/laptopwpeople.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/linear-bg-mobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/linear-bg.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/middleSchool1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/middleSchool2.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/news-1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/opportunities-readme-closed-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/opportunities-readme-closed.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/opportunities-readme-open-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/opportunities.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/opportunities1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/opportunities2.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/opportunities3.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/opportunities4.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/policy.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/privacy.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/product-blue.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/product-pink.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/product-placeholder.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/product-purple.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/puzzle.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/quality.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/readme-why-set.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/set-store.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/sharif.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/shiraz.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/sighn.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/students.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/welcomedesktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/welcomemobile.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/faq/FaqItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpportunitiesReadme"] */ "/app/src/sections/opportunities/Readme.tsx");
